// Audio utility functions to handle browser autoplay restrictions

let audioContext: AudioContext | null = null;
let userHasInteracted = false;

// Initialize audio context after user interaction
export const initializeAudioContext = () => {
  if (!userHasInteracted) {
    userHasInteracted = true;
    // Create a silent audio context to unlock audio
    if (!audioContext) {
      audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
  }
};

// Play notification sound with fallback
export const playNotificationSound = async (audioElement: HTMLAudioElement | null) => {
  if (!audioElement) return;

  try {
    // Ensure user has interacted
    if (!userHasInteracted) {
      console.log('Audio playback blocked: user has not interacted with the page');
      return;
    }

    // Reset audio and play
    audioElement.currentTime = 0;
    await audioElement.play();
  } catch (error) {
    console.log('Audio play failed:', error);
    
    // Fallback: try to resume audio context if suspended
    if (audioContext && audioContext.state === 'suspended') {
      try {
        await audioContext.resume();
        await audioElement.play();
      } catch (fallbackError) {
        console.log('Fallback audio play also failed:', fallbackError);
      }
    }
  }
};

// Add user interaction listeners
export const setupAudioInteraction = () => {
  const handleInteraction = () => {
    initializeAudioContext();
    
    // Remove listeners after first interaction
    document.removeEventListener('click', handleInteraction);
    document.removeEventListener('keydown', handleInteraction);
    document.removeEventListener('touchstart', handleInteraction);
    document.removeEventListener('mousedown', handleInteraction);
  };

  document.addEventListener('click', handleInteraction);
  document.addEventListener('keydown', handleInteraction);
  document.addEventListener('touchstart', handleInteraction);
  document.addEventListener('mousedown', handleInteraction);

  return () => {
    document.removeEventListener('click', handleInteraction);
    document.removeEventListener('keydown', handleInteraction);
    document.removeEventListener('touchstart', handleInteraction);
    document.removeEventListener('mousedown', handleInteraction);
  };
};

// Check if audio can be played
export const canPlayAudio = () => {
  return userHasInteracted;
}; 